const MAX_DIMENSION = 1200;
const TARGET_SIZE = 500 * 1024; // 500 KB
const QUALITY_STEPS = [0.8, 0.6, 0.4];

/**
 * Compress an image file to JPEG under TARGET_SIZE.
 * Resizes to MAX_DIMENSION on the longest edge, then iterates
 * quality levels until size constraint is met.
 */
export async function compressImage(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const { width, height } = bitmap;

  let w = width;
  let h = height;
  if (w > MAX_DIMENSION || h > MAX_DIMENSION) {
    const ratio = MAX_DIMENSION / Math.max(w, h);
    w = Math.round(w * ratio);
    h = Math.round(h * ratio);
  }

  const canvas = new OffscreenCanvas(w, h);
  const ctx = canvas.getContext("2d")!;
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close();

  for (const quality of QUALITY_STEPS) {
    const blob = await canvas.convertToBlob({ type: "image/jpeg", quality });
    if (blob.size <= TARGET_SIZE) return blob;
  }

  // Return lowest quality if still over target
  return canvas.convertToBlob({ type: "image/jpeg", quality: 0.3 });
}
